import { createTheme } from '@mui/material/styles';

import { components } from './components';
import { darkPalette, lightPalette } from './palette';
import { typography } from './typography';

const sharedConfig = {
  typography,
  shape: { borderRadius: 12 },
  spacing: 8,
  components,
} as const;

export const lightTheme = createTheme({
  ...sharedConfig,
  palette: lightPalette,
});

export const darkTheme = createTheme({
  ...sharedConfig,
  palette: darkPalette,
});
